import React, { useState } from 'react';
import Header from '../components/header';
import PageMenu from '../components/pagemenu';
import ErrorBoundary from '../components/ErrorBoundary';
import PowderInventory from '../components/inventory/PowderInventory';

// Inventory, reached from the header menu. Everyone signed in can see and update it.
function Inventory() {
  const [isAuthenticated, setIsAuthenticated] = useState(Boolean(localStorage.getItem('authToken')));

  return (
    <div className="App">
      <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      {isAuthenticated ? (
        <ErrorBoundary>
          <PowderInventory />
        </ErrorBoundary>
      ) : (
        <div>Please log in to view content</div>
      )}
      <PageMenu className="bottom-nav" />
    </div>
  );
}

export default Inventory;
